import {
  FilterMode,
  EsignatureRecipient_OrderBy,
  EsignatureRecipient,
  SortOrder,
  EsignatureRecipient_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const esignatureRecipientService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.esignatureRecipientOne({ id });
    return result.esignatureRecipientOne as EsignatureRecipient;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EsignatureRecipient_OrderBy[] | null = null,
    filter: EsignatureRecipient_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EsignatureRecipient_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
          { email: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.esignatureRecipientListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ name: SortOrder.Asc }, { email: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.esignatureRecipientListWithOffset
    ) as EsignatureRecipient[];
    return { list, orderBy };
  },
};
